import { c as _c } from "react/compiler-runtime";
import { ToggleButton } from "@opensea/ui-kit";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslations } from "use-intl";
export const AdjustForFeesSwitch = () => {
  const $ = _c(5);
  const t = useTranslations("wallet.AdjustForFeesSwitch");
  const {
    control
  } = useFormContext();
  let t0;
  if ($[0] !== t) {
    t0 = t1 => {
      const {
        field
      } = t1;
      const adjustForFees = field.value;
      return <ToggleButton checked={adjustForFees} className={adjustForFees ? "bg-bg-additional-1" : ""} onClick={() => field.onChange(!adjustForFees)} size="sm">{t("adjustForFees")}</ToggleButton>;
    };
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== control || $[3] !== t0) {
    t1 = <Controller control={control} name="adjustForFees" render={t0} />;
    $[2] = control;
    $[3] = t0;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
};